// NPM
import { combineReducers } from 'redux';
// Reducers
import endpointErrors from './endpointErrorsReducer';
import apiErrors from './apiErrorsReducer';
import isFetching from './loadingStateReducer';
import auth from './authReducer';
import authProviderUrls from './authProvidersReducer';
import survey from './surveyReducer';
import openModal from './modalReducer';
import pagination from './paginationReducer';
import filters from './filtersReducer';
import tagSearchResults from './tagSearchResultsReducer';
import hidingRecommendation from './hidingRecommendationReducer';
import currentResult from './currentResultReducer';

import { REFRESH_TOKEN_FAILURE, LOGOUT } from 'actionTypes';
import { pick } from 'lodash';
import entities from './entities';

const appReducer = combineReducers({
  auth,
  authProviderUrls,
  entities,
  endpointErrors,
  apiErrors,
  isFetching,
  survey,
  openModal,
  pagination,
  filters,
  tagSearchResults,
  hidingRecommendation,
  currentResult,
});

export default function rootReducer(state, action) {
  switch (action.type) {
    case REFRESH_TOKEN_FAILURE:
    case LOGOUT:
      const resultEntityKeys = [
        'recommendations',
        'categories',
        'subcategories',
        'universities',
        'cities',
        'provinces',
        'summaries',
      ];
      const resultEntities = pick(state.entities, resultEntityKeys);
      return appReducer({ entities: resultEntities }, action);
    default:
      return appReducer(state, action);
  }
}



// WEBPACK FOOTER //
// ./src/reducers/index.js